module.exports = __webpack_public_path__ + "static/media/broxel-vertical-spa.369bee83.png";